import React from 'react';
import './TempNotAvailable.scss';
import { TranslateFunction } from '../../types';

interface Props {
	backAvailableFrom?: string;
	compact?: boolean;
    t: TranslateFunction;
}

export const TempNotAvailable = (props: Props) => {
	const { backAvailableFrom, compact, t } = props;

	return (
		<div className={compact ? 'TempNotAvailableCompact' : 'TempNotAvailable'}>
			<div className='header'>
				{t('order.tempNotAvailableHeader')}
			</div>

			{!!backAvailableFrom && <div className='body'>
				{t('order.tempNotAvailableBody')} {!compact && <br />}{backAvailableFrom}
			</div>}
		</div>
	);
};
